/* global window */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// actions
import { addProducts } from '../../../actions/orders';
import { getEvents } from '../../../actions/cardEvents';

// components
import CardTitlePart from '../../../parts/CardTitlePart';
import VideoPart from '../../../parts/VideoPart/';
import ImagePart from '../../../parts/ImagePart';
import GhostButton from '../../../parts/GhostButton';
import TextCTA from '../../../layout/buttons/TextCTA';

import HtmlPart from '../../../parts/HtmlPart';
import OverlayLoader from '../../../parts/OverlayLoader';
import SuccessConfirmationOverlay from '../../../parts/SuccessConfirmationOverlay';
import FailureOverlay from '../../../parts/FailureOverlay';

import { gtmSimplePageLoadEvent } from '../../../services/gtmService';

class _AddSofaShield extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loadState: false,
      activeProduct: props.sofaShield && props.sofaShield != null ? 'sofashield' : 'technical',
      toAdd: []
    };
    if (props.parentCardName && props.parentCardName === 'DeliveryFlow') {
      gtmSimplePageLoadEvent(`${props.parentCardName} page ${props.thisCardName}`);
    }
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleAddProducts = this.handleAddProducts.bind(this);
    this.handleDismissCard = this.handleDismissCard.bind(this);
    this.handleAddSofaShield = this.handleAddSofaShield.bind(this);
    this.handleAddTechnical = this.handleAddTechnical.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const oldProps = this.props;
    // reset the card if the offered products changes to prevent technical without sofashield
    // eslint-disable-next-line eqeqeq
    const sameSofashield = oldProps.sofaShield == nextProps.sofashield;
    // eslint-disable-next-line eqeqeq
    const sameTechnical = oldProps.sofaShieldTechnical == nextProps.sofaShieldTechnical;
    if(!sameSofashield || !sameTechnical) {
      this.setState({
        loadState: false,
        activeProduct: nextProps.sofaShield && nextProps.sofaShield != null ? 'sofashield' : 'technical',
        toAdd: []
      });
    }
  }

  componentDidUpdate() {
    if (this.state.loadState === false && // prevent refiring once loading
        this.props.isSofologist && this.state.activeProduct === 'terms' &&
        ['OUTBOUND', 'CSL-DIRECT'].includes(this.props.sofologist.location)) {
      this.handleAddProducts();
    }
  }

  handleSuccess(res) {
    this.setState({ loadState: 'success' });
    return res;
  }

  handleError() {
    this.setState({ loadState: 'failure' });
    window.setTimeout(() => {
      this.setState({ loadState: false });
    }, 5000);
  }

  handleAddProducts() {
    const toAdd = this.state.toAdd;
    if (toAdd.length) {
      this.setState({ loadState: 'loading' });
      const { id, orderIdx, queueMessage, groupId, orderRef, orderNo } = this.props;

      return this.props.addProducts(id, orderIdx, queueMessage, groupId, orderRef, orderNo, this.state.toAdd)
        .then(this.handleSuccess)
        .then((res) => {
          if (res.data !== true) {
            return Promise.reject();
          }
          this.props.getEvents();
          return res.data;
        }).catch(() => {
          this.handleError();
        });
    }
    return Promise.resolve();
  }

  handleDismissCard(forceDismiss = false) {
    if (!forceDismiss && this.state.toAdd.length) {
      return this.setState({ activeProduct: 'terms' });
      // add product call should dismiss card for us.
    }
    this.setState({ loadState: 'loading' });
    return this.props.dismissCard()
      .catch(() => this.handleError());
  }

  handleAddSofaShield() {
    if (this.props.sofaShieldTechnical &&
      !this.state.toAdd.find(x => x.catalogueNumber === this.props.sofaShield.catalogueNumber)) {


      return this.setState(prev => ({
        toAdd: [...prev.toAdd, this.props.sofaShield],
        activeProduct: 'technical'
      }));
    }
    return this.setState(prev => ({
      toAdd: [...prev.toAdd, this.props.sofaShield],
      activeProduct: 'terms'
    }));
  }

  handleAddTechnical() {
    if (!this.state.toAdd.find(x => x.catalogueNumber === this.props.sofaShieldTechnical.catalogueNumber)) {
      return this.setState(prev => ({
        toAdd: [...prev.toAdd, this.props.sofaShieldTechnical],
        activeProduct: 'terms'
      }));
    }
    return this.setState({ activeProduct: 'terms' });
  }

  gatherProductData(p) {
    return {
      sofashield: {
        title: p.sofaShieldTitle,
        headerImage: p.sofaShieldHeaderImage,
        headerAltText: p.sofaShieldHeaderAltText,
        headerVideo: p.sofaShieldHeaderVideo,
        bodyText: p.sofaShieldBodyText,
        product: p.sofaShield,
        confirmText: p.sofaShieldConfirmText,
        dismissText: p.sofaShieldDismissText
      },
      technical: {
        title: p.technicalTitle,
        headerImage: p.technicalHeaderImage,
        headerAltText: p.technicalHeaderAltText,
        headerVideo: p.technicalHeaderVideo,
        bodyText: p.technicalBodyText,
        product: p.sofaShieldTechnical,
        confirmText: p.technicalConfirmText,
        dismissText: p.technicalDismissText
      }
    };
  }

  render() {
    const { orderRef, orderNo } = this.props;
    const productData = this.gatherProductData(this.props)[this.state.activeProduct];
    return (
      <div>

        {this.state.activeProduct === 'terms' ? renderTerms.call(this) : (
          <React.Fragment>
            <CardTitlePart title={productData.title || ''} />
            {
              productData.headerVideo ?
                <VideoPart
                  videoUrl={productData.headerVideo}
                  fallbackImage={productData.headerImage}
                  fallBackAlt={productData.headerAltText}
                  autoplay
                /> :
                <ImagePart url={productData.headerImage} alt={productData.headerAltText} />
            }

            <div
              className="c-event-feed__card__splitter u-padding-x-tiny u-flex u-flex-justify-space-between"
            >

              <OverlayLoader active={this.state.loadState === 'loading'} scale={0.5} background="rgba(255, 255, 255, 0.8)" />

              {this.state.loadState === 'success' ? <SuccessConfirmationOverlay /> : null}
              {this.state.loadState === 'failure' ? <FailureOverlay alpha={1} /> : null}

              <div className="left-text u-padding-x-tiny"><strong>Only £{productData.product.price}</strong></div>

              <div className="u-text-nowrap">
                {this.state.activeProduct === 'sofashield' && renderSofaShieldButtons.call(this, productData)}
                {this.state.activeProduct === 'technical' && renderTechnicalButtons.call(this, productData)}
              </div>

            </div>

            {
              productData.bodyText ?
                <div className="u-padding-x-medium u-padding-top-small">
                  <HtmlPart htmlString={productData.bodyText} />
                </div> : null
            }
          </React.Fragment>
        )}

        <div className="u-padding-tiny u-padding-y-small u-text-center c-event-feed__card__extra-info">
          <strong>Order Number:</strong> {`${orderRef}/${orderNo}`}
        </div>

      </div>
    );
  }
}

function renderSofaShieldButtons(productData) {
  return (
    <React.Fragment>
      <GhostButton
        text={productData.dismissText}
        position={'right'}
        align={'right'}
        type={'confirm'}
        onBtnClick={() => this.handleDismissCard()}
        extraClass={'c-btn c-btn--ghost u-text-nowrap u-margin-right-micro'}
        disabled={this.state.loadState}
      />

      <GhostButton
        text={productData.confirmText}
        position={'right'}
        align={'right'}
        type={'confirm'}
        loading={this.state.loadState === 'loading'}
        onBtnClick={this.handleAddSofaShield}
        extraClass={'c-btn c-btn--ghost u-margin-left-micro u-text-nowrap'}
        disabled={this.state.loadState}
      />
    </React.Fragment>
  );
}

function renderTechnicalButtons(productData) {
  return (
    <React.Fragment>
      <GhostButton
        text={productData.dismissText}
        position={'right'}
        align={'right'}
        type={'confirm'}
        onBtnClick={() => this.handleDismissCard()}
        extraClass={'c-btn c-btn--ghost u-text-nowrap u-margin-right-micro'}
        disabled={this.state.loadState}
      />

      <GhostButton
        text={productData.confirmText}
        position={'right'}
        align={'right'}
        type={'confirm'}
        loading={this.state.loadState === 'loading'}
        onBtnClick={this.handleAddTechnical}
        extraClass={'c-btn c-btn--ghost u-margin-left-micro u-text-nowrap'}
        disabled={this.state.loadState}
      />
    </React.Fragment>
  );
}


function renderTerms() {
  const skipTerms = this.props.isSofologist && ['OUTBOUND', 'CSL-DIRECT'].includes(this.props.sofologist.location);
  return (
    <React.Fragment>

      <CardTitlePart title={skipTerms ? 'Adding Sofashield Items' : 'Terms and Conditions'} />

      <div className="u-position-relative u-padding-top-medium u-padding-x-small">
        <OverlayLoader active={this.state.loadState === 'loading'} scale={0.5} background="rgba(255, 255, 255, 1)" />

        {this.state.loadState === 'success' ? <SuccessConfirmationOverlay /> : null}
        {this.state.loadState === 'failure' ? <FailureOverlay alpha={1} /> : null}

        <div className="c-html-part u-padding-left-small">
          <span>By continuing you agree that</span>

          <ul className="o-list-dots u-padding-left-medium u-padding-top-small">
            <li className="o-list-dots__item">You have had access to the <a rel="noreferrer noopener" target="_blank" href="https://www.sofology.co.uk/terms-and-conditions">Terms and Conditions</a>. You will receive your certificate of insurance 21 days after the delivery of your Product)</li>
            <li className="o-list-dots__item">You have read and understood the <a rel="noreferrer noopener" target="_blank" href="/ssTerms">Insurance Product Information Document (IPID)</a></li>
            <li className="o-list-dots__item">You are satisfied that these terms meet your demands and needs.</li>
          </ul>
        </div>

        <div className="u-padding-top-small">
          <div className="u-flex u-flex-justify--center u-padding-bottom-small">
            <GhostButton
              onBtnClick={this.handleAddProducts}
              extraClass="u-w-80"
              text="Continue"
            />
          </div>

          <div className="u-flex u-flex-justify--center">
            <TextCTA
              onBtnClick={() => this.handleDismissCard(true)}
              extraClass="c-btn--text--dissuade u-text-underline"
              text="Remove SofaShield"
            />
          </div>
        </div>

      </div>
    </React.Fragment>
  );
}

const mapStateToProps = state => ({
  isSofologist: state.sofologist.Authorized,
  sofologist: state.sofologist,
});

const mapDispatchToProps = dispatch => bindActionCreators({ addProducts, getEvents }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(_AddSofaShield);



// WEBPACK FOOTER //
// ./src/cards/templates/AddSofaShieldCard/index.js